import React, { Fragment, FunctionComponent } from "react";
import HomePageProps from "./HomePageProps.interface";

import ContentPageBlock from "pages/ContentPage/ContentPage.block";

const HomePage: FunctionComponent<HomePageProps> = (props) => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent, index) => {
                return <ContentPageBlock key={blockContent?.contentUdi} {...blockContent} />;
            })}
        </Fragment>
    );
};

export default HomePage;